export const dashboardTrackingId = `services3hdb-5188`;
export const trackerTrackingId = `services3hdb-5187`;
export const stageATrackingId = `services3hdb-5043`;
export const stageBTrackingId = `services3hdb-5189`;
export const stageCTrackingId = `services3hdb-5190`;
export const stageDTrackingId = `services3hdb-5191`;
export const stageETrackingId = `services3hdb-5192`;
